import {isPC} from '../utils/methods'

let scrollTops, $children, phoneScrollTop, $root, offsetTopArr, $target

const deviationVal = isPC() ? -140 : 20
const _reduce = arr => arr.reduce((total, current, index) => {
    arr[index] = total
    return total + current
})

const distanceToTop = (screenHeight, elHeightArr) => elHeightArr.map(el => el - screenHeight)
const confirmRoot = () => $root = isPC() ? document.documentElement : document.body
const letElementShow = ($children, scrollTop) =>
           $children.some((child, index) =>
           child.isActive === false
           && scrollTop > scrollTops[index] + deviationVal ?
           child.isActive = true : '')

const routeChange = (scrollTop) => {
    let number = 0
    offsetTopArr.forEach(item => item.offsetTop - 10 < scrollTop ? number++ : '')
    if (number && `#/#${offsetTopArr[number - 1].name}` !== location.hash) {
        location.href = `#/#${offsetTopArr[number - 1].name}`
    }
    if (scrollTop === 0) {
        location.href = `#/#home`
    }
}
const phoneScroll = () => {
    window.requestAnimationFrame(() => {
        let target = $target.$children[0]
        target.bs.on('scroll', () => {
            let scrollTop = -target.bs.y
            phoneScrollTop = scrollTop
            letElementShow($children, scrollTop)
        })
    })
}
const pcScroll = () => {
    let {scrollTop} = document.querySelector('#app')
    routeChange(scrollTop)
    letElementShow($children, scrollTop)
}

function scrollTopsArr($els) {
    let scrollTops = componentsOffsetTop($els)
    let obj = {}
    scrollTops.forEach(item => {
        obj[item.name] = item.offsetTop
    })
    return obj
}

function componentsOffsetTop($els) {
    let [collectArr, deviation] = [[], 35]
    $els.map(child => child.name ? collectArr.push({offsetTop: child.$el.offsetTop - deviation, name: child.name}) : '')
    return collectArr
}

function collectElementArr($el) {
    let childrenScrollHeight = []
    $children = $el.$children
    $children.map(child => childrenScrollHeight.push(child.$el.scrollHeight))
    _reduce(childrenScrollHeight)
    return childrenScrollHeight
}


function elementShowAddActive(self) {
    $target = self
    confirmRoot()
    const screenHeight = window.innerHeight
    let ElementsHeight = collectElementArr(self)
    scrollTops = distanceToTop(screenHeight, ElementsHeight)
    offsetTopArr = componentsOffsetTop(self.$children)
    if (isPC()) return document.querySelector('#app').addEventListener('scroll', pcScroll)
    phoneScroll()
}


function destroyEventListener() {
    if (isPC()) return document.querySelector('#app').removeEventListener('scroll', pcScroll)
}

export {
    elementShowAddActive,
    collectElementArr,
    scrollTopsArr,
    destroyEventListener
}
